export const DEFAULT_ZOOM_LEVEL = 17;
export const SITE_PLAN_GOOGLE_ZOOM = 1;
export const LAT_DEGREE = 110.574;
export const GOOGLE_MAP_PIXEL_WIDTH = 660;
export const PARTNER_TOKENS = ['084721106b0d95c1a5f5d4e5f83b9001'];

export const DEFAULT_PRIMARY_COLOR = '#0f3b5f';
export const DEFAULT_PRIMARY_TEXT_COLOR = '#FFFFFF';
export const DEFAULT_SECONDARY_COLOR = '#7c7b7a';
export const DEFAULT_BG_COLOR = '#F5F5F5';
export const DEFAULT_HIGHLIGHT_COLOR = '#00ff61';
export const DEFAULT_FONT_FAMILY = '"Montserrat", sans-serif';
